function submitLoanRepaymentData() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const repaymentDate = $('#add-loan-repayment-form input[name="loan_repayment[repayment_date]"]').val()
    const principalAmount = $('#add-loan-repayment-form input[name="loan_repayment[principal_amount]"]').val()
    const interestAmount =$('#add-loan-repayment-form input[name="loan_repayment[interest_amount]"]').val()
    const loanID = $('#add-loan-repayment-form input[name="loan_repayment[loan_id]"]').val()

    if (isEmpty(repaymentDate) || isEmpty(principalAmount) ||
      isEmpty(interestAmount)) {
      errorString.push(' Date, principal, interest required!');
    }

    const paymentOptions = getPaymentOptionsStorage()

    if (paymentOptions === null ||
      paymentOptions === undefined ||
      (Array.isArray(paymentOptions) && paymentOptions.length === 0)) {
      errorString.push('Payment option amount not set')
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#add-loan-repayment-form').attr('action')
      const paymentOptions = getPaymentOptionsStorage()


      let action = "post"

      if ($('#add-loan-repayment-form input[name="loan_repayment[loan_repayment_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          payment_options: paymentOptions,
          loan_repayment: {
            repayment_date: repaymentDate,
            principal_amount: removeCommas(principalAmount),
            interest_amount: removeCommas(interestAmount),
            loan_id: loanID
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(data.redirect_url)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}

$(document).ready(function () {
  if ($('#add-loan-repayment-form').length > 0) {

    if ($('.principal-amount-div').length > 0) {
      checkAmount('.principal-amount', '.principal-amount-div');
    }

    if ($('.interest-amount-div').length > 0) {
      checkAmount('.interest-amount', '.interest-amount-div');
    }

    submitLoanRepaymentData()
    clearFailedSubmit('#add-loan-repayment-form')
  }
});
